import {createReducer, on} from '@ngrx/store';
import {
  clearStopManyDestinationsState,
  stopManyDestinations,
  stopManyDestinationsFailure,
  stopManyDestinationsSuccess
} from './destination.stop-many.actions';
import {Destination} from '../../../services/api/destinations/destination.model';


export interface State {
  record: Destination[] | null;
  error: any | null;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false
};


export const stopManyDestinationsReducer = createReducer(
  initialState,

  on(stopManyDestinations, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: true
  })),
  on(stopManyDestinationsSuccess, (): State => ({
    record: null,
    error: null,
    loaded: true,
    loading: false
  })),
  on(stopManyDestinationsFailure, (_state: State, action): State => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false
  })),
  on(clearStopManyDestinationsState, (): State => ({
    record: null,
    error: null,
    loaded: false,
    loading: false
  }))
);

